import React from 'react'

const DisplayContext = React.createContext({})
export const DisplayProvider = DisplayContext.Provider
export default DisplayContext
